export interface ExpectedValueBadgeProps {
  /** Pre-formatted display string, e.g. "$25.21". */
  value: string;
}

/**
 * ExpectedValueBadge — зелёный accent-pill с числовым значением (Expected
 * Value). Цвет жёстко зашит `#25ea1e` — параметризация через DS theme
 * прилёт в Plan 5 (schema).
 *
 * Выделено из modules/odds/OddsPanel.tsx.
 */
export function ExpectedValueBadge({ value }: ExpectedValueBadgeProps) {
  return (
    <div
      data-co-component="ExpectedValueBadge"
      className="
        relative flex h-7 items-center justify-center [border-radius:var(--co-ExpectedValueBadge-borderRadius,8px)] px-[7px]
        bg-[color:var(--co-ExpectedValueBadge-bgTint,rgba(37,234,30,0.22))]
        shadow-[0_0_4px_0_rgba(32,233,25,0.3),inset_0_0_7px_0_rgba(32,233,25,0.6)]
      "
    >
      <span className="type-headline font-semibold text-[color:var(--co-ExpectedValueBadge-text,#25ea1e)] [font-family:var(--font-primary,var(--font-sans))] drop-shadow-[0_0_4px_rgba(32,233,25,0.3)]">
        {value}
      </span>
    </div>
  );
}
